export default function toAlphanumeric(str: string) {
  return str.replace(/[^a-zA-Z0-9]/g, "");
}

export function validateFilename(str: string) {
  const lastDotIndex = str.lastIndexOf(".");
  const namePart = str.substring(0, lastDotIndex);
  const filename = toAlphanumeric(namePart);
  const extension = str.substring(lastDotIndex);

  return filename + extension;
}
